export default __webpack_public_path__ + "static/media/9.41b37f18.jpeg";